import { RG_TYPE } from "@project-rouge/rg-core";
function getClosingCost(state, props) {
  let closingCost = 0;
  for (let i = 0; i < 2; i++) {
    if (props.canCloseEnds[i] && props.endClosingDistances[i] === 0) {
      const n = i === 0 ? 0 : state.sequence.length - 1;
      const action = state.sequence[n];
      if (!action)
        return 0;
      if (action.unit.type === RG_TYPE.Apartment && action.unit.data.closeCorridor)
        continue;
      else
        closingCost += 0.5;
    }
  }
  return closingCost;
}
export {
  getClosingCost
};
//# sourceMappingURL=index213.js.map
